<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/training-videos"></back-button> 
            Edit course
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Main</li>
            <li><router-link to="/training-videos">Training Videos</router-link></li>
            <li class="active">Create</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-md-6">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 col-xs-12">
                    <div class="form-wrap form-horizontal">
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Course Name*</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="text" class="form-control" placeholder="Course Name" v-model="form.course_name">
                          <span class="error-block">{{ errors.course_name }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Course Description</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="text" class="form-control" placeholder="Course Description" v-model="form.description">
                          <span class="error-block">{{ errors.description }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Instructor</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="text" class="form-control" placeholder="Instructor" v-model="form.instructor">
                          <span class="error-block">{{ errors.instructor }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">No of hrs</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="number" class="form-control" placeholder="No of hrs" v-model="form.no_of_hrs">
                          <span class="error-block">{{ errors.no_of_hrs }}</span>
                        </div>
                      </div>
                      <div class="form-group mb-0">
                        <div class="col-sm-offset-3 col-sm-9">
                          <submit-button :isLoading="isLoading" @submit="update" text="Update"></submit-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>

  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'trainingVideoEdit',
  data () {
    return {
      form: {
      },
      isLoading: false,
    }
  },
  mounted() {
    this.form.site_id = this.site.id
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      let form = await axios.get(`/courses/${this.$route.params.trainingVideoId}`)
      this.form = form.data.data
      this.isLoading = false
    },
    async update() {
      try {
        this.isLoading = true
        await axios.patch(`/courses/${this.$route.params.trainingVideoId}`, this.form)
        this.isLoading = false
        this.$router.push('/training-videos')
      } catch(e) {
        this.isLoading = false
      }
    }
  }
}
</script>